export default __webpack_public_path__ + "static/media/mena9.88df2860.PNG";